import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import PropTypes from 'prop-types';
import { CustomBox, CustomButton } from './cardan-alter-buttons.styles';

function CardanAlterButtons(_ref) {
  let {
    buttons,
    isRow
  } = _ref,
      containerProps = _objectWithoutPropertiesLoose(_ref, ["buttons", "isRow"]);

  return /*#__PURE__*/React.createElement(CustomBox, _extends({
    "data-testid": "cardan-alter-button-box",
    isRow: isRow
  }, containerProps), buttons.map((button, index) => /*#__PURE__*/React.createElement(CustomButton, {
    key: `button-${button.label}-${index}`,
    onClick: button.onClick,
    border: button.border,
    variation: "outline",
    uppercase: false,
    size: "large",
    isRow: isRow,
    "data-testid": `cardan-alter-button-${index}`
  }, button.label)));
}

const ButtonPropType = process.env.NODE_ENV !== "production" ? PropTypes.shape({
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  border: PropTypes.bool
}) : {};
process.env.NODE_ENV !== "production" ? CardanAlterButtons.propTypes = {
  buttons: PropTypes.arrayOf(ButtonPropType),
  isRow: PropTypes.bool
} : void 0;
CardanAlterButtons.defaultProps = {
  buttons: [{
    label: 'Alterar veículo',
    onClick: () => {}
  }],
  isRow: false
};
export default CardanAlterButtons;